import React, {useCallback, useEffect, useState} from "react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {RootState} from "../../../Store/Reducers";
import {useDispatch, useSelector} from "react-redux";
import {ModalActions} from "../../../Store/Modal/Slice";
import {SHIPMENT_PROVE_MODAL} from "../../../Store/Modal/Types";
import {getShipmentSalttoService} from "../../../Services";
import {BASE64} from "../../../Utils/Constants";

const ShipmentProveModal = () => {

  const dispatch = useDispatch();

  const {shipmentProveModal: {open, data}} = useSelector((state: RootState) => state.ModalReducer);

  const [previewPdf, setPreviewPdf] = useState({invoiceBase64Bytes: '', remittanceBase64Bytes: ''});
  const [errorMessage, setErrorMessage] = useState('');

  const handleCloseModal = () => {
    dispatch(ModalActions.closeModal({modal: SHIPMENT_PROVE_MODAL}));
  };

  const getShipmentPDF = useCallback(async () => {
    const res = await getShipmentSalttoService({consecutive: data?.consecutive});
    if (res?.success) {
      setPreviewPdf(res);
    } else {
      setErrorMessage(`Hubo un error, Intente de nuevo o contacte soporte.`);
    }
  }, [data]);


  useEffect(() => {
    if (data?._KEY) {
      getShipmentPDF();
    }
  }, [data, getShipmentPDF]);

  return (
    <Modal size="xl" toggle={handleCloseModal} isOpen={open}>
      <ModalHeader toggle={handleCloseModal} className="border-0">
        Detalle de la guía # {data?.consecutive}
      </ModalHeader>
      <ModalBody>

        {!previewPdf.remittanceBase64Bytes && !errorMessage &&
        <div className="pdf-spinner-container">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        }

        {errorMessage ?
          <div className="error-container">
            <b className="text-danger">{errorMessage}</b>
          </div> :
          <iframe title="shipment-preview" className="pdf-size"
                  src={`${!!previewPdf?.remittanceBase64Bytes ? `${BASE64}${previewPdf.remittanceBase64Bytes}` : ''}`}/>

        }
        {!!previewPdf.invoiceBase64Bytes &&
        <>
          <h4 className="my-4">Factura</h4>
          <iframe title="shipment-preview" className="pdf-size" src={`${BASE64}${previewPdf.invoiceBase64Bytes}`}/>
        </>
        }

      </ModalBody>
    </Modal>
  );
};

export default ShipmentProveModal;
